//* Libraries imports
import { CircularProgress } from "@mui/material";
import { motion } from "framer-motion"; 
import { ProcessActions } from "./process-actions";
import styles from "../_components/styles/process-table.module.scss";

interface ProcessField {
  name: string;
  header: string;
  type: "text" | "date" | "boolean";
}

interface ProcessTableProps {
  fields: ProcessField[];
  items: any[];
  loading: boolean;
  notFoundMessage: string;
  onEditProcess?: (id: number) => void;
  onDeleteProcess?: (id: number) => void;
  onViewProcess?: (id: number) => void;
  hideEdit?: boolean;
  hideDelete?: boolean;
}

export function ProcessTable({
  fields,
  items,
  loading,
  notFoundMessage,
  onEditProcess,
  onDeleteProcess,
  onViewProcess,
  hideEdit = false,
  hideDelete = false,
}: ProcessTableProps) {


  const rowVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.05, 
        duration: 0.3,
      },
    }), 
  };

  if (loading) {
    return (
      <div className="row p-0">
        <div className="col-12 d-flex justify-content-center align-items-center">
          <CircularProgress data-testid="loading-spinner" />
        </div>
      </div>
    );
  }

  
  if (!items || items.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.3 }}
        className="row w-100"
      >
        <div className="col-12">
          <p className={styles.notFoundMessage}>
            {notFoundMessage}
          </p>
        </div>
      </motion.div>
    );
  }
  return (
    <div className="table-rep-plugin">
      <div
        className={`table-responsive mb-0 ${styles.tableContainer}`}
        data-pattern="priority-columns"
      >
        <table
          id="tech-companies-1"
          className={`table table-hover ${styles.table}`}
        >
          <thead>
            <tr>
              {fields.map((field, idx) => (
                <th key={idx}>{field.header}</th>
              ))}
              <th className={styles.actionsColumn} data-priority="3">Ações</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <motion.tr
                key={index}
                custom={index}
                initial="hidden"
                animate="visible"
                variants={rowVariants}
                layout 
              >
                {fields.map((field, fieldId) => {
                  if (field.type === "text") {
                    return (
                      <td key={fieldId}>
                        <div dangerouslySetInnerHTML={{ __html: item[field.name]?.toString() || "" }} />
                      </td>
                    );
                  }
                  
                  if (field.type === "date") {
                    return (
                      <td key={fieldId}>
                        {item[field.name]?.human?.date
                          ? item[field.name].human.date
                          : "-"}
                      </td>
                    );
                  }

                  if (field.type === "boolean") {
                    return (
                      <td key={fieldId}>
                        {item[field.name] ? "Sim" : "Não"}
                      </td>
                    );
                  }                  
                  
                  return (
                    <td key={fieldId}>
                      [undefined type]
                    </td>
                  );
                })}

                <td className={styles.actionsColumn}>
                  <ProcessActions
                    processId={item.id}
                    onViewClick={onViewProcess ? () => onViewProcess(item.id) : undefined}
                    onEditClick={onEditProcess ? () => onEditProcess(item.id) : undefined}
                    onDeleteClick={onDeleteProcess ? () => onDeleteProcess(item.id) : undefined}
                    hideEdit={hideEdit}
                    hideDelete={hideDelete}
                  />
                </td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
